import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, Alert, Form } from 'react-bootstrap';
import styled from 'styled-components';

import NavMenu from './../../sharedComponents/NavMenu';
import RegisterModal from '../../sharedComponents/RegisterModal';
import SigninModal from '../../sharedComponents/SigninModal';
import ThankyouModal from '../../sharedComponents/ThankyouModal';
import ForgotPasswordModal from '../../sharedComponents/ForgotPasswordModal';
import ResetPasswordModal from '../../sharedComponents/ResetPasswordModal';
import CustomLoading from '../../sharedComponents/CustomLoading';
import SidePanel from './SidePanel';
import TourItem from './TourItem';
import OptionPanel from '../../sharedComponents/OptionPanel';
import RequestHelper from '../../utils/Request.Utils';
import * as CONSTANT from '../../constants';

import TourList from '../Homepage/TourList';
import TourCRUD from './TourCRUD/TourCRUD';
import ManageUser from './ManageUser/ManageUser';

const Dashboard = () => {
  const [curTab, setTab] = useState('Tours');
  const [showOptionPanel, setShowOptionPanel] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showFailAlert, setShowFailAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tourList, setTourList] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');

  const { userToken, userInfo } = useSelector((state: any) => ({
    userToken: state.user.token,
    userInfo: state.user.user,
  }))

  useEffect(() => {
    if (!userToken) return;
    if (curTab === 'Tours') return;
    if (curTab === 'Users') return;
    setIsLoading(true);
    RequestHelper
      .get('/tour-session/list', null)
      .then((res) => {
        if (!res.data.success) {
          setShowFailAlert(true);
          setTourList([]);
          window.setTimeout(() => { setShowFailAlert(false) }, 2000);
        } else {
          let tourArray = res.data.data;
          tourArray.sort((a: any, b: any) => {
            return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
          })
          setTourList(tourArray);
        }
        setIsLoading(false);
      })
  }, [curTab, userToken])

  const handleChange = (selectedTab: string) => {
    setTab(selectedTab);
  }

  const removeTourSession = async (tour) => {
    const shouldRemove = window.confirm(`Are you sure you want to remove this tour session (${tour?.tourName})?`);
    if (!shouldRemove) return;
    const res = await RequestHelper.postNextServer('/clear-tour-session', {
      id: tour?.ID,
    });
    if (!res.data.success) alert('An error occcurs');
    setTourList(tourList.filter(val => val.ID !== tour.ID));
  }

  const removeAllTourSessions = async () => {
    const shouldRemove = window.confirm(`Are you sure you want to remove all tour sessions?`);
    if (!shouldRemove) return;
    const res = await RequestHelper.postNextServer('/clear-tour-session', {
      ids: tourList?.map(i => i?.ID),
    });
    if (!res.data.success) alert('An error occcurs');
    setTourList([]);
  }

  const onChangeKeyword = useCallback((e) => {
    setSearchKeyword(e.target.value);
  }, []);

  if (!userInfo || (
    userInfo.role !== CONSTANT.UserRoles.broker
    && userInfo.role !== CONSTANT.UserRoles.admin
  )) {
    return (
      <>
        <NavMenu />
        <div className="dashboard main-container container">
          <h4 className="text-center">Access Denied</h4>
        </div>
        <RegisterModal role="broker" />
        <SigninModal role="broker, admin" />
        <ThankyouModal type="register" />
        <ForgotPasswordModal />
        <ResetPasswordModal />

        <Alert variant="success" show={showSuccessAlert}>Tour Request sent successfully!</Alert>
        <Alert variant="danger" show={showFailAlert}>Error! Permision Denied! You must login as a {CONSTANT.ROLES.broker}!</Alert>
      </>
    )
  }

  return (
    <>
      <NavMenu />
      <div className="dashboard main-container container">
        <div className="main-page-section">
          <SidePanel curTab={curTab} setTab={(selectedTab: string) => { handleChange(selectedTab) }} />
          <MainPanel id="main-panel">
            <div className="content-wrapper">
              <div className="header d-flex justify-content-between align-items-center py-2 px-4">
                <h1 className="m-0">Dashboard</h1>
                {curTab === 'Tours' && (
                  <Form>
                    <Form.Control
                      value={searchKeyword}
                      placeholder="Search..."
                      onChange={onChangeKeyword}
                    />
                  </Form>
                )}
                {curTab === 'Pending' && (
                  <button
                    className="add-new-button"
                    onClick={removeAllTourSessions}
                  >
                    Clear all
                  </button>
                )}
              </div>
              <div className="content p-4">
                {isLoading ? (
                  <CustomLoading />
                ) : curTab === 'Tours' ? (
                  <TourCRUD searchKeyword={searchKeyword} />
                ) : curTab === 'Users' ? (
                  <ManageUser />
                ) : (
                  tourList && tourList.length > 0 ?
                    (tourList.map((item, nIndex) => {
                      return (
                        <div className="col-md-6 mb-3 p-0 float-left" key={nIndex}>
                          <TourItem tourInfo={item} clearSession={() => removeTourSession(item)} />
                        </div>
                      );
                    }))
                    : (<div className="no-result">You have no connected Guided Tours</div>)
                )}
              </div>
            </div>
          </MainPanel>
          {showOptionPanel ?
            <OptionPanel isShow={showOptionPanel} hidePanel={() => setShowOptionPanel(false)} customStyle={{ position: 'absolute', right: '2rem' }} />
            : null}
        </div>
      </div>


    </>
  )
}

const MainPanel = styled.div`
  padding-right: 2rem;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  position: relative;

  .content-wrapper {
    background: white;
    flex: 1;
  }
`

const DropdownToggle = styled(Dropdown.Toggle)`
  background: transparent !important;
  border: none;
  outline: none;
  box-shadow: none !important;
  line-height: 0;

  &:hover {
    background
  }
  &:before {
    display: none !important;
  }
  padding-top: 0;
`
const Bar = styled.div`
  width: 26px;
  height: 2px;
  background: #2E2D2C;
  margin-bottom: 6px;
  &:last-child {
    margin-bottom: 0
  }  
`
export default Dashboard
